<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/users/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New user
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'user'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/admins`"
    />
  </v-container>
</template>

<script>
export default {
  name: "UserList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Username', value: 'username' },
      { text: 'Firstname', value: 'firstname' },
      { text: 'Lastname', value: 'lastname' },
      { text: 'Email', value: 'email' },
      { text: 'Phone number', value: 'phone_number' },
      { text: 'Line ID', value: 'line_id' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['username', 'firstname', 'lastname', 'email','phone_number', 'line_id'],
    search_param: '',
    attribute_list: ['id', 'username', 'firstname', 'lastname', 'email','phone_number', 'line_id'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
